var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locations card"},[_c('page-header',{attrs:{"title":"Location","breadcrumb":"Dashboard >> Locations"}}),_c('locations-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }